
import { useState } from 'react';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StarRatingProps {
  value: number;
  max?: number;
  size?: 'sm' | 'md' | 'lg';
  onChange?: (rating: number) => void;
  readonly?: boolean;
  className?: string;
}

export function StarRating({
  value,
  max = 5,
  size = 'md',
  onChange,
  readonly = false,
  className,
}: StarRatingProps) {
  const [hoverRating, setHoverRating] = useState<number | null>(null);

  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  const handleMouseEnter = (rating: number) => {
    if (readonly) return;
    setHoverRating(rating);
  };

  const handleMouseLeave = () => {
    if (readonly) return;
    setHoverRating(null);
  };

  const handleClick = (rating: number) => {
    if (readonly) return;
    onChange?.(rating);
  };

  return (
    <div className={cn('flex', className)}>
      {[...Array(max)].map((_, i) => {
        const rating = i + 1;
        const isActive = (hoverRating !== null ? hoverRating : value) >= rating;
        
        return (
          <span
            key={i}
            className={cn(
              'cursor-default transition-all duration-200',
              !readonly && 'cursor-pointer hover:scale-110'
            )}
            onMouseEnter={() => handleMouseEnter(rating)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(rating)}
          >
            <Star
              className={cn(
                sizeClasses[size],
                isActive 
                  ? 'fill-purple-400 text-purple-400 drop-shadow-[0_0_6px_rgba(168,85,247,0.6)]' 
                  : 'text-gray-500',
                'transition-all duration-200'
              )}
            />
          </span>
        );
      })}
    </div>
  );
}
